import React from 'react'
import AlphabetCell from '../AlphabetCell'

const PlayfairTable = ({ selectedPlain, selectedCipher, keyTable }) => {

    function checkCipher(c){
        if (selectedCipher[0] === "J") selectedCipher[0] = "I"
        if (selectedCipher[1] === "J") selectedCipher[1] = "I"
        return selectedCipher[0] === c || selectedCipher[1] === c
    }
    function checkPlain(p){
        if (selectedPlain[0] === "J") selectedPlain[0] = "I"
        if (selectedPlain[1] === "J") selectedPlain[1] = "I"
        return selectedPlain[0] === p || selectedPlain[1] === p
    }

    return (
        <div style={{ textAlign: "center" , width:"300px"}}>

            {keyTable.map((row) => (
                <div style={{ display: "inline-block", margin: 0 }}>
                    <AlphabetCell key={Math.random()} text={row[0]} isCipher={checkCipher(row[0])} isPlain={checkPlain(row[0])} />
                    <AlphabetCell key={Math.random()} text={row[1]} isCipher={checkCipher(row[1])} isPlain={checkPlain(row[1])} />
                    <AlphabetCell key={Math.random()} text={row[2]} isCipher={checkCipher(row[2])} isPlain={checkPlain(row[2])} />
                    <AlphabetCell key={Math.random()} text={row[3]} isCipher={checkCipher(row[3])} isPlain={checkPlain(row[3])} />
                    <AlphabetCell key={Math.random()} text={row[4]} isCipher={checkCipher(row[4])} isPlain={checkPlain(row[4])} isLast={true} />
                    <br/>
            </div>
            ))}
            
        </div>
    );

}

export default PlayfairTable